import EcoSpace from 'eco-design/base/eco-space';
import BannerA from '../../components/BannerA';
import EcoAi from '../../components/EcoAi';
import Engineering from '../../components/Engineering';
import Essentials from '../../components/Essentials';
import FooterTcA from '../../components/FooterTcA';
import OnlineStoreRightsA from '../../components/OnlineStoreRightsA3';
import PathToZero from '../../components/PathToZero';
import Plug from '../../components/Plug';
import PowerOceanA from '../../components/PowerOceanA';
import ProductListStatusB from '../../components/ProductListStatusB';
import SeamLess from '../../components/SeamLess';
import SectionA1 from '../../components/SectionA1';
import SectionA2 from '../../components/SectionA2';
import SectionA3 from '../../components/SectionA3';
import SectionB1 from '../../components/SectionB1';
import SectionB2 from '../../components/SectionB2';
import StepPortal from '../../components/StepPortal';
import Assistant from '../../components/Assistant';
import SubscribeWinUltraA from '../../components/SubscribeWinUltraA2';
import Certification from '../../components/Certification';
import CertificationBanner from '../../components/CertificationBanner';
import BreakLimits from '../../components/BreakLimits';
import SolarPowerV2 from '../../components/SolarPower-V2';
import Spread from '../../components/Spread';
import { useRouter } from 'next/router';

export default function StatusItem() {
    const { locale = 'eu' } = useRouter();
    const isEU = ['eu', 'uk', 'de'].includes(locale);
    return (
        <>
            <BannerA />
            <CertificationBanner />
            <div className="product-box">
                <PathToZero />
                <EcoSpace hPc="160px" hPad="100px" />
                <OnlineStoreRightsA />
                {/* <OnlineStoreRightsNa /> */}
                <ProductListStatusB />
                {/* <EcoSpace hPc="160px" /> */}
                {/* <SubscribeWinUltraA /> */}
                <SectionA1 />
                <SectionA2 />
                <BreakLimits />
                <SectionA3 pageType="normal" />
                <SolarPowerV2 pageType="normal" />
                <Essentials pageType="normal" />
                {locale !== 'uk' && <Plug pageType="normal" />}
                {/* <SectionB1 pageType="normal" /> */}
                <SectionB2 pageType="normal" />
                {isEU && <Spread pageType="normal" />}

                <div style={{ background: '#000' }}>
                    <EcoAi pageType="normal" />
                    <SeamLess pageType="normal" />
                    <Assistant pageType="normal" />
                </div>
                <Engineering />
                {/* <ProductContrast /> */}
                <EcoSpace hPc="160px" hPad="100px" />
                {/* <ChoosePlanModule /> */}
                <Certification />
                <EcoSpace hPc="160px" hPad="100px" hH5="0" />
                <PowerOceanA />
                <EcoSpace hPc="160px" hPad="100px" hH5="0" />
                <FooterTcA />
            </div>
        </>
    );
}
